import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { UploadProgressProps } from '../../../types/reduxTypes/uploadProgress';

const createReducer = <T extends SliceCaseReducers<UploadProgressProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setUploadProgressData(state, action) {
    state.uploadProgressData = action.payload;
  }
});

export default reducers;
